module.exports = __webpack_public_path__ + "static/media/07 Alto Bari Sax Region 20 Scales.16ac3650.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/07 Alto Bari Sax Region 20 Scales.pdf
// module id = 267
// module chunks = 0